<template>
  <v-row
    class="overflow-y-auto row-container"
    :style="$vuetify.display.mobile ? 'height: 130vh;' : undefined"
  >
    <v-col cols="12">
      <v-card flat>
        <template v-slot:text>
          <v-row>
            <v-col cols="12" md="3" lg="3" xl="3">
              <p class="mb-2">Country</p>
              <v-autocomplete
                v-if="(isAllCountry === 1) | (isAdmin === 1)"
                v-model="countryId"
                :items="countries"
                :item-title="'name'"
                :item-value="'id'"
                variant="outlined"
                prepend-inner-icon="mdi-flag-outline"
                required
                autocomplete="off"
                persistent-placeholder
                class="style-chooser"
                @update:modelValue="filterItems"
              >
              </v-autocomplete>

              <!-- NOTE: when we use @update.movelValue or :on-change the data return to json 
                                      but else the data return as value normally -->
              <v-autocomplete
                v-else
                v-model="countryId"
                :items="countries"
                :item-title="'name'"
                :item-value="'id'"
                variant="outlined"
                prepend-inner-icon="mdi-flag-outline"
                required
                autocomplete="off"
                persistent-placeholder
                placeholder="Choose customer..."
                disabled
                @update:modelValue="filterItems"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" lg="3" xl="3">
              <p class="mb-2">Currency</p>
              <v-autocomplete
                v-model="currency"
                :items="itemsCurrency"
                :item-title="'name'"
                :item-value="'id'"
                variant="outlined"
                prepend-inner-icon="mdi-flag-outline"
                required
                autocomplete="off"
                persistent-placeholder
                class="style-chooser"
                @update:modelValue="filterItems"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xl="3">
              <p class="mb-2">User</p>
              <v-select
                v-model="searchTestOrNormal"
                :items="['-- All --', 'Normal', 'Test']"
                :item-title="'name'"
                :item-value="'id'"
                label="User"
                variant="outlined"
                prepend-inner-icon="mdi-account-outline"
                required
                persistent-placeholder
                placeholder="Choose user..."
                return-object
                single-line
                @update:modelValue="filterItems"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="3" lg="3" xl="3">
              <p class="mb-2">Search</p>
              <v-text-field
                v-model="search"
                label="Search customer..."
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                single-line
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-snackbar
            v-model="snack"
            :timeout="3000"
            :color="snackColor"
            location="top"
          >
            {{ snackText }}
          </v-snackbar>
        </template>
        <v-row>
          <v-col cols="6" md="6" lg="6" xl="6" class="d-flex align-center mb-4">
            <!-- <v-btn
              v-if="isAdminOrFinance"
              class="mb-2 mr-2"
              color="primary"
              prepend-icon="mdi-sync-off"
              variant="flat"
              @click="openconfirmAndReject"
            >
              <div class="text-none font-weight-regular">Confirm/Reject</div>
            </v-btn> -->
          </v-col>

          <v-col
            cols="6"
            md="6"
            lg="6"
            xl="6"
            class="text-right d-flex mb-6 flex-row-reverse"
          >
            <v-sheet class="ma-2 pa-2 text-center">
              <v-select
                v-model="perPage"
                :items="[10, 25, 50, 100, 1000, 10000]"
                hide-details
                density="compact"
                variant="outlined"
                @update:model-value="perPage = parseInt($event, 10)"
                style="width: 100px"
              ></v-select>
            </v-sheet>
            <v-sheet class="my-6 text-subtitle-2">Items</v-sheet>
          </v-col>
        </v-row>

        <v-tabs
          v-model="tab"
          align-tabs="end"
          @click="filterItems"
          color="deep-purple-accent-4"
        >
          <v-tab :value="0">All</v-tab>
          <v-tab :value="1">Pending</v-tab>
          <v-tab :value="2">Successful</v-tab>
          <v-tab :value="3">Fail</v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab">
          <v-tabs-window-item v-for="n in 5" :key="n" :value="n">
            <v-container fluid>
              <v-row>
                <v-data-table
                  color="#b2d7ef"
                  rounded="compact"
                  divided
                  striped
                  hover
                  class="elevation-1"
                  fixed-header
                  :search="search"
                  :headers="headers"
                  :items="depositCollection"
                  :items-per-page="perPage"
                  :server-items-length="totalCount"
                  :loading="loading"
                  v-model="depositSelected"
                  @update:modelValue="handleSelectAll"
                  @click:row.stop="handleRowClick"
                  :sort-by="[{ key: 'created_at', order: 'desc' }]"
                >
                  <template v-slot:top>
                    <v-dialog
                      v-model="dialog"
                      persistent
                      transition="dialog-bottom-transition"
                      max-width="600px"
                    >
                      <v-card>
                        <v-card-title
                          style="background-color: #005bac; color: white"
                        >
                          <span class="headline">Confirm Deposit</span>
                        </v-card-title>
                        <divider class="mb-0"></divider>
                        <v-card-text>
                          <v-row>
                            <!-- QR Code -->
                            <v-col
                              cols="12"
                              class="d-flex justify-center"
                              v-show="isCrypto"
                            >
                              <div class="qr-container">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                  "
                                >
                                  <v-img
                                    :src="usdt_qr_code"
                                    class="mb-3"
                                    aspect-ratio="16/9"
                                    width="100"
                                    style="margin-right: 10px"
                                  />
                                  <v-img
                                    :src="voucher"
                                    v-if="voucher"
                                    class="mb-3"
                                    aspect-ratio="16/9"
                                    width="100"
                                  />
                                </div>
                                <div class="amount-overlay">{{ amount }} $</div>
                              </div>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="name"
                                readonly
                                label="Depositer Name"
                                variant="outlined"
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="paymentMethod"
                                readonly
                                label="Method payment"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="bankName"
                                readonly
                                label="Bank name"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="cardNumber"
                                readonly
                                label="Card number"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="cvc"
                                readonly
                                label="CVC"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="expireMonth"
                                readonly
                                label="Expired month"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isCrypto"
                            >
                              <v-text-field
                                v-model="expiryYear"
                                readonly
                                label="Expired year"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <!-- block crypto -->
                            <v-col cols="12" v-show="isCrypto">
                              <v-text-field
                                v-model="usdt_link"
                                :label="copy"
                                readonly
                                variant="outlined"
                                @click:append-inner="copyCode"
                                :append-inner-icon="
                                  copied ? copied : 'mdi-content-copy'
                                "
                                :class="{ copied: copied, 'copy-icon': true }"
                                style="margin-bottom: 0%"
                              >
                                <template v-slot:append-inner>
                                  <span
                                    v-if="copied"
                                    style="
                                      font-size: small;
                                      display: inline-flex;
                                    "
                                    ><v-icon style="margin-right: 4px"
                                      >mdi-check</v-icon
                                    >Copied</span
                                  >
                                </template>
                              </v-text-field>
                            </v-col>

                            <!-- Crypto -->
                            <!-- Bank -->
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isNormalBank"
                            >
                              <v-text-field
                                v-model="accountName"
                                readonly
                                label="Account Name"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"
                              v-show="isNormalBank"
                            >
                              <v-text-field
                                v-model="accountNumber"
                                readonly
                                label="Account Number"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <!-- nd Bank -->

                            <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                              <v-text-field
                                v-model="phone"
                                readonly
                                label="Phone"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                              <v-text-field
                                v-model="created_at"
                                readonly
                                label="Deposit at"
                                variant="outlined"
                                type="tel"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>

                        <v-card-actions
                          class="d-flex justify-end pa-4"
                          style="background-color: #f5f5f5"
                        >
                          <v-btn
                            color="blue"
                            outlined
                            rounded
                            class="ma-2"
                            @click="clearContent()"
                          >
                            <v-icon start>mdi-close</v-icon> Close
                          </v-btn>
                          <v-btn
                            color="error"
                            outlined
                            rounded
                            class="ma-2"
                            @click="rejectDeposit"
                            :disabled="isSubmitting"
                          >
                            <v-icon start>mdi-cancel</v-icon> Reject
                          </v-btn>
                          <v-btn
                            color="green"
                            outlined
                            rounded
                            class="ma-2"
                            @click="submitData"
                            :disabled="isSubmitting"
                          >
                            <v-icon start>mdi-check</v-icon> Confirm
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialogImage"
                      persistent
                      fullscreen
                      transition="dialog-bottom-transition"
                    >
                      <v-card>
                        <v-toolbar>
                          <v-toolbar-title prepend-icon="mdi-form-textbox"
                            >Image Card</v-toolbar-title
                          >

                          <v-btn
                            icon="mdi-close"
                            @click="closeDialgeImage"
                          ></v-btn>
                        </v-toolbar>
                        <v-divider class="mb-0"></v-divider>
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              :lazy-src="frontCard"
                              :src="frontCard"
                              aspect-ratio="1"
                              class="bg-grey-lighten-2"
                              height="85vh"
                              contain
                              max-width="auto"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  align="center"
                                  class="fill-height ma-0"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    color="grey-lighten-5"
                                    indeterminate
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-col>
                        </v-row>
                        <v-card-actions class="my-2 d-flex justify-end">
                          <v-spacer></v-spacer>
                          <v-btn
                            class="text-none"
                            rounded="xl"
                            text="Cancel"
                            @click="closeDialgeImage"
                          ></v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <!-- <ConfirmDeposit
                      v-if="depositSelected.length > 0"
                      v-model="showRejectDialog"
                      :item="statusPendingSelected"
                    ></ConfirmDeposit> -->
                  </template>
                  <!-- detect when error  -->
                  <template v-slot:no-data>
                    <v-alert
                      v-if="items.length > 0"
                      :value="true"
                      color="error"
                      icon="warning"
                      class="text-left"
                    >
                      No data found.
                    </v-alert>
                  </template>
                  <!-- end detect when error  -->
                  <!-- Custom column table -->

                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      size="small"
                      v-if="item.status === 'pending'"
                      color="info"
                    >
                      {{ item.status }}
                    </v-chip>
                    <v-chip
                      size="small"
                      v-if="item.status === 'successful'"
                      color="success"
                    >
                      {{ item.status }}
                    </v-chip>
                    <v-chip
                      size="small"
                      v-if="item.status === 'fail'"
                      color="error"
                    >
                      {{ item.status }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.customer.profile`]="{ item }">
                    <v-avatar
                      size="64"
                      class="my-1"
                      v-if="item.customer.profile !== null"
                    >
                      <v-img :src="path + item.customer.profile" cover></v-img>
                    </v-avatar>
                    <v-avatar
                      class="my-1"
                      v-else
                      image="https://th.bing.com/th/id/OIP.tcFOyXBrh18mT9xQUPgB8gHaHv?rs=1&pid=ImgDetMain"
                      size="80"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          align="center"
                          class="fill-height ma-0"
                          justify="center"
                        >
                          <v-progress-circular
                            color="grey-lighten-5"
                            indeterminate
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-avatar>
                    <!--
                        <v-span class="ml-2">
                          {{ item.name }}
                        </v-span> -->
                  </template>
                  <template v-slot:[`item.created_at`]="{ item }">
                    {{ new Date(item.created_at).toLocaleString() }}
                  </template>
                  <template v-slot:[`item.amount_dollar`]="{ item }">
                    {{ convertNumber1000To1K1M1B(item.amount_dollar) }}
                  </template>
                  <template v-slot:[`item.tax_fee`]="{ item }">
                    {{ convertNumber1000To1K1M1B(item.tax_fee) }}
                  </template>
                  <template v-slot:[`item.fee`]="{ item }">
                    {{ convertNumber1000To1K1M1B(item.fee) }}
                  </template>
                  <template v-slot:[`item.deposit_amount_currency`]="{ item }">
                    {{
                      convertNumber1000To1K1M1B(item.deposit_amount_currency)
                    }}
                  </template>
                  <template v-slot:[`item.amount_received`]="{ item }">
                    {{ convertNumber1000To1K1M1B(item.amount_received) }}
                  </template>
                  <template v-slot:[`item.deposit_amount`]="{ item }">
                    {{ convertNumber1000To1K1M1B(item.deposit_amount) }}
                  </template>
                  <template
                    v-slot:[`item.BankAccountDeposit.voucher`]="{ item }"
                  >
                    <v-avatar
                      size="64"
                      class="my-1"
                      v-if="item.BankAccountDeposit.voucher"
                    >
                      <v-img
                        alt="Avatar"
                        :src="
                          path_voucher_image + item.BankAccountDeposit.voucher
                        "
                        cover
                      >
                        <template v-slot:placeholder>
                          <v-row
                            align="center"
                            class="fill-height ma-0"
                            justify="center"
                          >
                            <v-progress-circular
                              color="grey-lighten-5"
                              indeterminate
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                    <v-avatar class="my-1" v-else size="64">
                      <v-img
                        alt="Avatar"
                        src="https://th.bing.com/th/id/OIP.tcFOyXBrh18mT9xQUPgB8gHaHv?rs=1&pid=ImgDetMain"
                        cover
                      >
                        <template v-slot:placeholder>
                          <v-row
                            align="center"
                            class="fill-height ma-0"
                            justify="center"
                          >
                            <v-progress-circular
                              color="grey-lighten-5"
                              indeterminate
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </template>
                  <template v-slot:[`item.bankAccount.usdtQr`]="{ item }">
                    <v-avatar
                      size="64"
                      class="my-1"
                      v-if="item.bankAccount.usdtQr"
                    >
                      <v-img
                        alt="Avatar"
                        :src="path_usdt_qr_image + item.bankAccount.usdtQr"
                        cover
                      >
                        <template v-slot:placeholder>
                          <v-row
                            align="center"
                            class="fill-height ma-0"
                            justify="center"
                          >
                            <v-progress-circular
                              color="grey-lighten-5"
                              indeterminate
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                    <v-avatar class="my-1" v-else size="64">
                      <v-img
                        alt="Avatar"
                        src="https://th.bing.com/th/id/OIP.tcFOyXBrh18mT9xQUPgB8gHaHv?rs=1&pid=ImgDetMain"
                        cover
                      >
                        <template v-slot:placeholder>
                          <v-row
                            align="center"
                            class="fill-height ma-0"
                            justify="center"
                          >
                            <v-progress-circular
                              color="grey-lighten-5"
                              indeterminate
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </template>
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                        v-model="page"
                        rounded="circle"
                        :length="pageCount"
                        :total-visible="7"
                        @update:model-value="
                          PopulatedepositCollection(staffLoginCountryCode)
                        "
                      ></v-pagination>
                    </div>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      class="ma-2"
                      size="x-small"
                      :color="
                        item.status === 'pending'
                          ? 'red-lighten-2'
                          : 'grey-lighten-2'
                      "
                      :disabled="item.status !== 'pending'"
                      @click="editItem(item)"
                    >
                      <v-icon icon="mdi-pencil" start></v-icon>
                      confirm
                    </v-btn>
                  </template>
                  <!-- End custom column table -->
                </v-data-table>
              </v-row>
            </v-container>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import {
  Path_Customer_Image,
  Path_QRBANK_IMAGE,
  Path_USDQR_IMAGE,
  URL_CONFIRM_DEPOSIT,
  URL_COUNTRY,
  URL_GET_DEPOSIT_CURRENCY_BY_DISTINCT,
  URL_PERMISSION,
  URL_UPDATE_CONFIRM_DEPOSIT,
  URL_UPDATE_REJECT_DEPOSIT,
} from "@/utils/apiUrl";
import { getTokenHeaders } from "@/utils/headerToken";
import { formatNumber, originalCode } from "@/utils/formatNumber";

let qrImage =
  "https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg";

export default {
  // components: { ConfirmDeposit },
  data: () => ({
    path: Path_Customer_Image,
    path_usdt_qr_image: Path_USDQR_IMAGE,
    path_qr_bank_image: Path_QRBANK_IMAGE,
    path_voucher_image: Path_QRBANK_IMAGE,
    loading: false, // Loading state
    tab: null,
    snack: false,
    copied: false, // To toggle the copied icon state
    snackbar: false, // To control the snackbar visibility
    dialog: false,
    dialogImage: false,
    showRejectDialog: false,
    visible: false,
    isAdminOrFinance: false,
    isSubmitting: false, // To prevent multiple submissions
    isNormalBank: false,
    isCrypto: false,

    items: [],
    countries: [{ id: 0, name: "-- All --" }],
    statusItems: [],
    depositCollection: [],
    depositSelected: [],
    statusPendingSelected: [],
    itemsCurrency: [],

    search: null,
    searchTestOrNormal: "-- All --",
    currency: null,
    snackColor: null,
    snackText: null,
    profile: null,

    editedIndex: -1,
    hiddenId: 0,
    status: "All",
    countryId: 0,

    usdt_link: null, // Example code to be copied
    usdt_qr_code: "", // QR code URL
    name: "",
    phone: "",
    created_at: "",
    copy: "USDT Link",
    amount: 0,
    customerId: null,
    wallet: 0,
    paymentMethod: null,
    bankName: null,
    cardNumber: null,
    cvc: null,
    expireMonth: null,
    expiryYear: null,
    defaultQrImage: qrImage,
    accountName: null,
    accountNumber: null,
    voucher: null,

    //pagination
    page: 1,
    perPage: 10,
    pageCount: 0,
    totalCount: 0, // Total records count

    isAdmin: originalCode(parseInt(localStorage.getItem("admin"))),
    isAllCountry: originalCode(parseInt(localStorage.getItem("allCountry"))),
    staffLoginCountryCode: originalCode(parseInt(localStorage.getItem("code"))),
    staffLoginCountryId: originalCode(
      parseInt(localStorage.getItem("countryId"))
    ),
    staffLoginId: originalCode(parseInt(localStorage.getItem("id"))),

    headers: [
      { title: "", key: "actions", sortable: false, align: "center" },
      { title: "Voucher", key: "BankAccountDeposit.voucher", align: "center" },
      {
        title: "USDT QR",
        key: "bankAccount.usdtQr",
        align: "center",
      },
      { title: "Country", key: "Customer.country", align: "center" },
      { title: "Status", key: "status", align: "center" },
      {
        title: "Bank",
        key: "bankAccount.bankType.bankName",
        align: "center",
      },
      {
        title: "Payment Method",
        key: "bankAccount.bankType.paymentMethod",
        align: "center",
      },
      {
        title: "Account Name",
        key: "BankAccountDeposit.bank_account",
        align: "center",
      },
      {
        title: "Account Number",
        key: "BankAccountDeposit.card_number",
        align: "center",
      },
      {
        title: "Account Wallet",
        key: "bankAccount.wallet",
        align: "center",
      },
      {
        title: "Card Number",
        key: "bankAccount.cardNumber",
        align: "center",
      },
      { title: "Depositer", key: "Customer.name", align: "center" },
      { title: "Currency", key: "currency", align: "center" },
      { title: "Deposit Amount", key: "deposit_amount", align: "center" },
      { title: "Amount Received", key: "amount_received", align: "center" },
      {
        title: "Deposit Amount Currency",
        key: "deposit_amount_currency",
        align: "center",
      },
      { title: "Tax Fee", key: "tax_fee", align: "center" },
      { title: "Fee", key: "fee", align: "center" },
      { title: "Amount Dollar", key: "amount_dollar", align: "center" },
      { title: "Purpose", key: "purpose", align: "center" },

      { title: "Phone", key: "Customer.phone", align: "center" },
      { title: "Address", key: "Customer.address", align: "center" },
      {
        title: "USDT Link",
        key: "bankAccount.usdtLink",
        align: "center",
      },

      { title: "Created At", key: "created_at", align: "center" },
      { title: "Confirm At", key: "confirm_at", align: "center" },
      { title: "Confirm By", key: "staff.fullName", align: "center" },
    ],
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogImage(val) {
      val || this.close();
    },
    page() {
      this.PopulatedepositCollection(this.staffLoginCountryCode);
    },
    perPage() {
      this.PopulatedepositCollection(this.staffLoginCountryCode);
    },
    search() {
      this.PopulatedepositCollection(this.staffLoginCountryCode);
    },
  },
  created() {
    this.staffLoginCountryCode =
      this.isAdminOrAllCountryPermission() ||
      this.getStaffPermissionCustomerByStaffLogin()
        ? null
        : this.staffLoginCountryCode;

    this.populateCurrencyDepositByDistinct();
    this.getStaffPermissionCustomerByStaffLogin();
    this.PopulateCountries();
    this.PopulatedepositCollection(this.staffLoginCountryCode);
  },
  methods: {
    async populateCurrencyDepositByDistinct() {
      try {
        const response = await axios.get(URL_GET_DEPOSIT_CURRENCY_BY_DISTINCT, {
          headers: getTokenHeaders(),
        });

        if (response.data) {
          // Add "All" option as first item
          this.itemsCurrency = [{ id: null, name: "-- All --" }];

          // Add currencies from response
          response.data.forEach((item) => {
            this.itemsCurrency.push({
              id: item.currency,
              name: item.currency,
            });
          });
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
        this.snakeMessage("error", "Failed to load currencies");
      }
    },
    clearContent() {
      this.hiddenId = 0;
      this.customerId = null;
      this.name = null;
      this.phone = null;
      this.amount = 0;
      this.created_at = null;
      this.paymentMethod = null;
      this.bankName = null;
      this.cardNumber = null;
      this.cvc = null;
      this.expireMonth = null;
      this.expiryYear = null;
      this.usdt_qr_code = null;
      this.voucher = null;
      this.usdt_link = null;
      this.accountName = null;
      this.accountNumber = null;
      this.isNormalBank = false;
      this.isCrypto = false;
      this.dialog = false;
    },
    // Method to copy code to clipboard
    copyCode() {
      navigator.clipboard
        .writeText(this.usdt_link)
        .then(() => {
          this.copied = true;
          this.snackbar = true;

          // Reset state after 2.5 seconds
          setTimeout(() => {
            this.copied = false;
            this.copy = "USDT Link";
          }, 2500);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    },

    isAdminOrAllCountryPermission() {
      return (this.isAdmin || this.isAllCountry) === 1 ? true : false;
    },

    async getStaffPermissionCustomerByStaffLogin() {
      var isPermissionCustomer = 0;
      var isAdmin = 0;
      var isFinance = 0;

      await axios
        .get(URL_PERMISSION + this.staffLoginId, { headers: getTokenHeaders() })
        .then((res) => {
          isPermissionCustomer = res.data.customerService;
          isAdmin = res.data.admin;
          isFinance = res.data.finance;

          this.isAdminOrFinance = isAdmin || isFinance === 0 ? true : false;
        });

      return isPermissionCustomer;
    },

    PopulateCountries() {
      axios
        .get(URL_COUNTRY, { headers: getTokenHeaders() })
        .then((response) => {
          response.data.forEach((country) => {
            this.countries.push({
              name: country.name,
              id: country.id,
              code: country.code,
            });
          });

          this.countryId = this.isAdminOrAllCountryPermission()
            ? this.countryId === 0
              ? "-- All --"
              : this.staffLoginCountryId
            : this.staffLoginCountryId;
        });
    },

    async filterItems(component) {
      switch (this.tab) {
        case 0:
          this.status = "All";
          break;
        case 1:
          this.status = "pending";
          break;
        case 2:
          this.status = "successful";
          break;
        case 3:
          this.status = "fail";
          break;
      }

      //const countryCode = this.getCountryCodeByCountryId(component);
      const countryName = this.getCountryCodeByCountryId(component);
      this.PopulatedepositCollection(countryName);
    },

    getCountryCodeByCountryId(countryId) {
      if (countryId === 0) {
        return this.staffLoginCountryCode;
      }
      const country = this.countries.find((item) => item.id === countryId);
      return country ? country.name : null;
    },

    async PopulatedepositCollection(countryCode) {
      const params = {
        page: this.page,
        perPage: this.perPage,
        countryName: countryCode,
        status: this.status,
        currency: this.currency,
        typeUser:
          this.searchTestOrNormal === "-- All --"
            ? null
            : this.searchTestOrNormal,
        textSearch: this.search ? this.search : null,
      };

      this.loading = true;
      try {
        await axios
          .get(URL_CONFIRM_DEPOSIT, {
            params,
            headers: getTokenHeaders(),
          })
          .then((response) => {
            if (response.data && response.data.depositCollection) {
              this.depositCollection = response.data.depositCollection;
              this.totalCount = response.data.totalCount;
              this.pageCount = response.data.pageCount;
              this.items.push(this.depositCollection);
            } else {
              this.loading = false;
              console.warn("Empty API Response");
              this.depositCollection = [];
            }
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    openconfirmAndReject() {
      if (this.depositSelected.length === 0) {
        this.snakeMessage(
          "warning",
          "Please choose at least one customer to confirm or reject."
        );
      } else {
        this.statusPendingSelected = [];
        this.depositSelected.forEach(async (key) => {
          const deposit = this.depositCollection.find(
            (item) => item.id === key
          );

          if (
            deposit &&
            deposit.status === "pending" &&
            deposit.BankAccountDeposit.bankType.paymentMethod ===
              "Cryptocurrency"
          ) {
            this.statusPendingSelected.push(deposit);
          }
        });

        if (this.statusPendingSelected.length === 0) {
          this.snakeMessage(
            "warning",
            "Status 'Pending' and 'Cryptocurrency' are available to confirm."
          );
        } else {
          this.showRejectDialog = true;
        }
      }
    },

    handleSelectAll(itemSelected) {
      if (itemSelected.length === 0) {
        this.showRejectDialog = false;
        return false;
      }
    },

    handleRowClick(event, { item }) {
      // Prevent dialog from opening when selecting rows
      if (this.depositSelected.includes(item)) {
        event.stopPropagation();
      }
    },

    editItem(item) {
      if (item.status !== "pending") {
        this.snakeMessage("warning", "Only pending deposits can be confirmed.");
        return;
      }

      this.editedIndex = this.depositCollection.indexOf(item);
      this.hiddenId = item.id;
      this.customerId = item.customer_id;
      //this.editedItem = Object.assign({}, item);
      this.name = item.Customer.name;
      this.phone = item.Customer.phone;
      this.amount = `${item.amount_dollar}`;
      this.created_at = item.created_at
        ? new Date(item.created_at).toLocaleString()
        : null;

      if (item.bankAccount.bankType.paymentMethod === "Cryptocurrency") {
        this.isNormalBank = false;
        this.isCrypto = true;
        this.paymentMethod = item.bankAccount.bankType.paymentMethod;
        this.bankName = item.bankAccount.bankType.bankName;
        this.cardNumber = item.bankAccount.cardNumber;
        this.cvc = item.bankAccount.cvc;
        this.expireMonth = item.bankAccount.expire
          ? item.bankAccount.expire.slice(0, 2)
          : null;
        this.expiryYear = item.bankAccount.expire
          ? item.bankAccount.expire.slice(-2)
          : null;
        this.usdt_link = item.bankAccount.usdtLink;
        //this.qrCode(item.bankAccount.usdtQr);
        this.usdt_qr_code =
          item.bankAccount.usdtQr !== null
            ? this.path_usdt_qr_image + item.bankAccount.usdtQr
            : this.defaultQrImage;
        this.voucher =
          item.BankAccountDeposit.voucher !== null
            ? this.path_qr_bank_image + item.BankAccountDeposit.voucher
            : null;
      } else {
        this.isNormalBank = true;
        this.isCrypto = false;
        this.accountName = item.BankAccountDeposit.bank_account;
        this.accountNumber = item.BankAccountDeposit.card_number;
      }

      this.dialog = true;
    },

    // qrCode(usdtQrCode) {
    //   QRCode.toDataURL(usdtQrCode, (err, url) => {
    //     if (!err) {
    //       this.usdt_qr_code = url;
    //     }
    //   });
    // },

    async submitData() {
      if (this.isSubmitting) return; // Prevent multiple submissions
      this.isSubmitting = true;

      try {
        var status = "successful";
        await axios
          .patch(
            `${URL_UPDATE_CONFIRM_DEPOSIT}${this.hiddenId}/${this.customerId}/${status}/${this.amount}`,
            {},
            { headers: getTokenHeaders() }
          )
          .then((response) => {
            if (response.data) {
              this.snakeMessage("success", response.data.message);
              this.PopulatedepositCollection(this.staffLoginCountryCode);
              this.clearContent();
            } else {
              this.snakeMessage("error", response.data.message);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            this.snakeMessage("error", "An error occurred.");
          })
          .finally(() => {
            this.close();
          });
      } catch (error) {
        console.error(error);
      } finally {
        this.isSubmitting = false; // Re-enable the button after the request
      }
    },

    async rejectDeposit() {
      if (this.isSubmitting) return; // Prevent multiple submissions
      this.isSubmitting = true;

      try {
        var status = "fail";
        await axios
          .patch(
            `${URL_UPDATE_REJECT_DEPOSIT}${this.hiddenId}/${this.customerId}/${status}`,
            {},
            { headers: getTokenHeaders() }
          )
          .then((response) => {
            if (response.data) {
              this.snakeMessage("success", response.data.message);
              this.PopulatedepositCollection(this.staffLoginCountryCode);
              this.clearContent();
            } else {
              this.snakeMessage("error", response.data.message);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            this.snakeMessage("error", "An error occurred.");
          })
          .finally(() => {
            this.close();
          });
      } catch (error) {
        console.error(error);
      } finally {
        this.isSubmitting = false; // Re-enable the button after the request
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.clearContent();
        this.editedIndex = -1;
      });
    },

    closeDialgeImage() {
      this.dialogImage = false;
    },

    snakeMessage(color, message) {
      this.snack = true;
      this.snackColor = color;
      this.snackText = message;
      this.snackTextStyle = { fontSize: "32px" }; // Customize font size
      setTimeout(() => {
        this.snack = false;
      }, 3000);
    },

    convertNumber1000To1K1M1B(value) {
      return formatNumber(value);
    },
  },
};
</script>
<style scoped>
@import "vue-select/dist/vue-select.css";

.row-container {
  overflow-y: auto;
}

style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  border: 1px solid #d1d5db;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 55px;
  font-size: medium;
  color: #394066;
  max-height: 200px;
  overflow-y: auto;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}

.headline {
  font-size: 1.5rem;
  font-weight: bold;
}

.v-card {
  padding: 0;
}

.v-img {
  margin-top: 0px;
}

/* CSS for the animation when the icon changes */
.copied {
  transition: all 0.3s ease;
  color: red;
}

.qr-container {
  position: relative;
  display: inline-block;
  width: 80%;
  text-align: center;
}

.amount-overlay {
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
}
</style>
